import {
  faArrowCircleDown,
  faCheckCircle
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2, Heading3 } from 'components/shared/Typography.styled';
import { useI18n } from 'hooks/useI18n';
import { Link } from 'react-scroll';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledFeatureList,
  StyledHeader,
  StyledStep,
  StyledTab,
  StyledTabs
} from './Steps.styled';

export const TESteps: React.FC = () => {
  const { t } = useI18n('talent-engine-landing-v3');

  return (
    <StyledContainer>
      <StyledHeader>
        <Heading2 editorial>{t('talent-engine-landing.steps.title')}</Heading2>
      </StyledHeader>

      <StyledFeatureList>
        <StyledTabs>
          <StyledTab>
            <img src={getPublicPath('/images/talentEngine/te-step1.png')} />

            <Heading3 editorial>
              {t('talent-engine-landing.steps.step1.title')}
            </Heading3>

            <Link to="talentEngineConsultancy" href="#talentEngineConsultancy">
              <ButtonLink variant="brandTalent" as="div" sizes="s">
                <FontAwesomeIcon icon={faArrowCircleDown} />
                <span>{t('talent-engine-landing.steps.step1.cta')}</span>
              </ButtonLink>
            </Link>
          </StyledTab>

          <StyledTab>
            <img src={getPublicPath('/images/talentEngine/te-step2.png')} />

            <Heading3 editorial>
              {t('talent-engine-landing.steps.step2.title')}
            </Heading3>

            <Link to="talentEngineForm" href="#talentEngineForm">
              <ButtonLink variant="brandTalent" as="div" sizes="s">
                <FontAwesomeIcon icon={faArrowCircleDown} />
                <span>{t('talent-engine-landing.steps.step2.cta')}</span>
              </ButtonLink>
            </Link>
          </StyledTab>
        </StyledTabs>

        <StyledStep visible={true}>
          <div>
            <Heading3 editorial alignLeft>
              {t('talent-engine-landing.steps.step2.subtitle')}
            </Heading3>

            <HtmlTrans
              ns="talent-engine-landing-v3"
              i18nKey="talent-engine-landing.steps.step2.content"
            />

            <p>
              <Link to="talentEngineForm" href="#talentEngineForm">
                <ButtonLink variant="brandTalent" as="div" sizes="s">
                  <FontAwesomeIcon icon={faCheckCircle} />
                  <span>{t('talent-engine-landing.steps.step2.cta2')}</span>
                </ButtonLink>
              </Link>
            </p>
          </div>
          <div>
            <img src={getPublicPath('/images/talentEngine/te-step3.png')} />
          </div>
        </StyledStep>
      </StyledFeatureList>
    </StyledContainer>
  );
};
